import { File, Paths } from 'expo-file-system';
import * as Sharing from 'expo-sharing';
import * as DocumentPicker from 'expo-document-picker';
import { allDocs, replaceAll } from './store';
import { ymd } from '../lib/date';
import { t } from '../lib/i18n';
import { semBloqueio } from '../lib/ausencia';

/** Gera um arquivo com todos os dados (cópia própria, além da nuvem). */
export async function exportBackup() {
  const f = new File(Paths.cache, `myplanner-backup-${ymd(new Date())}.json`);
  if (f.exists) f.delete();
  f.create();
  f.write(JSON.stringify({ app: 'myplanner', formato: 2, criado_em: new Date().toISOString(), dados: allDocs() }));
  if (!(await Sharing.isAvailableAsync())) throw new Error(t('Compartilhamento indisponível neste dispositivo.'));
  await semBloqueio(() => Sharing.shareAsync(f.uri, { mimeType: 'application/json', dialogTitle: t('Salvar backup do My Planner') }));
}

export async function importBackup() {
  const r = await semBloqueio(() => DocumentPicker.getDocumentAsync({ type: ['application/json', '*/*'], copyToCacheDirectory: true }));
  if (r.canceled) return false;
  const json = JSON.parse(await new File(r.assets[0].uri).text());
  if (json?.app !== 'myplanner' || typeof json.dados !== 'object') throw new Error(t('Este arquivo não é um backup do My Planner.'));
  replaceAll(json.dados);
  return true;
}
